import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { useContactStore } from "../../../store/useContactStore";
import { formatPhoneNumberWithDash } from "../../../helper";

export default function ContactCol() {
  let { getContactInfo, contact } = useContactStore()
  return (
    <div className="contact-col">
      <div className="footer-heading">
        <h6 className="text-white">Contact Info</h6>
      </div>
      <ul className="list-unstyled footer-nav  text-white">
        {
          contact?.address &&
          (
            <li className="d-flex align-items-start">
              <span className="icon-holder me-3 mt-1">
                <FontAwesomeIcon icon={faLocationDot} />
              </span>
              <span>
                {
                  contact?.address
                }
              </span>
            </li>
          )
        }
        {
          contact?.email &&
          (
            <li className="d-flex align-items-center mb-2">
              <span className="icon-holder me-3">
                <FontAwesomeIcon icon={faEnvelope} />
              </span>
              <a
                href="mailto:info@arhamsoft.com"
                className="text-white text-decoration-none"
              >
                {
                  contact?.email
                }
              </a>
            </li>
          )
        }
        <li className="d-flex align-items-center mb-2">
          <span className="icon-holder me-3">
            <FontAwesomeIcon icon={faPhone} />
          </span>
          <a href="tel:6204830307" className="text-white text-decoration-none">
            {
              contact?.phoneNumber
              &&
              formatPhoneNumberWithDash(contact?.phoneNumber)
            }
          </a>
        </li>
      </ul>
    </div>
  );
}
